import { isValidDate, diffdays } from '../../utils/Validate';
import ValidateField from '../../hooks/useValid';
import { ValidateMessages } from '../../constants/ValidateConstants';
import { ValidateName } from '../../constants/ValidateNameConstants';

export default function validation(values, customerdata, projectdata) {
  let projectcheck;

  if (!values?.id)
    projectcheck = projectdata?.find((obj) => obj?.countryId == values?.countryId && obj?.projectName == values.projectName);
  else
    projectcheck = projectdata?.find((obj) => obj?.countryId == values?.countryId && obj?.projectName == values.projectName && obj?.id !== values?.id);

  const errors = {};
  errors.projectName = ValidateField(
    values.projectName,
    ValidateName?.PROJECT_NAME,
    ValidateName?.PROJECT_NAME,
    [ValidateName?.REQUIRED, ValidateName?.MIN_LENGTH],
  );

  errors.projectSegmentId = ValidateField(
    values.projectSegmentId,
    ValidateName?.PROJECT_SEGMENT,
    ValidateName?.PROJECT_SEGMENT,
    [ValidateName?.ISREQUIRED_NO]
  );

  errors.projectStatusId = ValidateField(
    values.projectStatusId,
    ValidateName?.PROJECT_STATUS,
    ValidateName?.PROJECT_STATUS,
    [ValidateName?.ISREQUIRED_NO]
  );

  errors.mainContractorId = ValidateField(
    values.mainContractorId,
    ValidateName?.MAIN_CONTRACTOR,
    ValidateName?.MAIN_CONTRACTOR,
    [ValidateName?.ISREQUIRED_NO]
  );

  errors.distributorId = ValidateField(
    values.distributorId,
    ValidateName?.DISTRIBUTOR,
    ValidateName?.DISTRIBUTOR,
    [ValidateName?.ISREQUIRED_NO]
  );

  errors.countryId = ValidateField(
    values.countryId,
    ValidateName?.COUNTRY,
    ValidateName?.COUNTRY,
    [ValidateName?.ISREQUIRED_NO]
  );

  errors.startDate = ValidateField(
    values.startDate,
    ValidateName?.START_DATE,
    ValidateName?.START_DATE,
    [ValidateName?.VALID_DATE]
  );

  errors.endDate = ValidateField(
    values.endDate,
    ValidateName?.END_DATE,
    ValidateName?.END_DATE,
    [ValidateName?.VALID_DATE]
  );

  if (projectcheck) {
    errors.projecterr = ValidateMessages?.SHOULD_SAME_FIELD_NAME("project");
  }

  if (isValidDate(values.endDate) && isValidDate(values.startDate)) {
    if (diffdays(values.startDate, values.endDate) < 0) {
      errors.endDate = ValidateMessages?.GREATER_START_DATE;
    }
  }

  let error = {}
  Object.keys(errors).map((key, index) => {
    if (errors[key] !== undefined)
      error[key] = errors[key]
  })
  return error;
}

export function validationContact(values, contact) {
  const errors = {};
  errors.name = ValidateField(
    values.name,
    ValidateName?.CONTACT_NAME,
    ValidateName?.CONTACT_NAME,
    [ValidateName?.REQUIRED, ValidateName?.ISTEXTONLY],
  );

  errors.department = ValidateField(
    values.departmentId,
    ValidateName?.DEPARTMENT,
    ValidateName?.DEPARTMENT,
    [ValidateName?.REQUIRED],
  );

  errors.email = ValidateField(
    values.email,
    ValidateName?.EMAIL,
    ValidateName?.EMAIL,
    [ValidateName?.REQUIRED, ValidateName?.ISVALID_EMAIL],
  );

  errors.phone = ValidateField(
    values.phone,
    ValidateName?.PHONE_NUMBER,
    ValidateName?.PHONE_NUMBER,
    [ValidateName?.REQUIRED, ValidateName?.ISVALID_PHONE],
  );

  errors.designation = ValidateField(
    values.designationId,
    ValidateName?.DESINATION,
    ValidateName?.DESINATION,
    [ValidateName?.REQUIRED],
  );

  errors.contact = ValidateField(
    values,
    ValidateName?.CONTACT_AVAILABLE,
    ValidateName?.CONTACT_AVAILABLE,
    [ValidateName?.UNIQUE_CONTACTS], undefined, contact
  );

  let error = {}
  Object.keys(errors).map((key, index) => {
    if (errors[key] !== undefined)
      error[key] = errors[key]
  })
  return error;
}
